export enum StickyTabsPricePromise {
    PROMISE = 'promise',
    DOORS = 'doors',
    SINKS = 'sinks',
    APPLIANCES = 'appliances',
    WORKTOPS = 'worktops',
    STORAGE = 'storage',
    ACCESSORIES = 'accessories'
};
